<template>
  <div class="menu-manage-container">
    <!-- 搜索表单 -->
    <el-form :inline="true" class="search-form">
      <div class="search-left">
        <el-form-item label="菜单名称">
          <el-input v-model="searchForm.menuName" placeholder="请输入菜单名称" style="width: 180px;"></el-input>
        </el-form-item>
        <el-form-item label="状态">
          <el-select v-model="searchForm.is_show" placeholder="菜单状态" style="width: 100px;">
            <el-option label="全部" value=""></el-option>
            <el-option label="显示" value="1"></el-option>
            <el-option label="隐藏" value="0"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="handleSearch">搜索</el-button>
        </el-form-item>
        <el-form-item>
          <el-button icon="el-icon-refresh" @click="handleReset">重置</el-button>
        </el-form-item>
      </div>
      <!-- 操作按钮 -->
      <div class="action-buttons">
        <el-button type="primary" icon="el-icon-plus" @click="handleAdd('isAdd')">新增</el-button>
        <el-button type="info" :icon="allExpanded ? 'el-icon-s-fold' : 'el-icon-s-unfold'" @click="toggleExpand">
          展开折叠
        </el-button>
      </div>
    </el-form>

    <!-- 菜单列表 -->
    <div class="table-container">
      <div class="table-scroll">
        <el-table :data="flattenedMenuList" style="width: 100%" border v-loading="loading">
          <el-table-column prop="menuName" label="菜单名称" align="center">
            <template slot-scope="scope">
              <span :style="{ paddingLeft: (scope.row.level * 20) + 'px' }">
                <i v-if="scope.row.hasChildren"
                  :class="scope.row.expanded ? 'el-icon-caret-bottom' : 'el-icon-caret-right'"
                  style="margin-right: 5px; cursor: pointer" @click="toggleMenu(scope.row)"></i>
                <i v-else style="margin-right: 18px;"></i>
                {{ scope.row.menuName }}
              </span>
            </template>
          </el-table-column>
          <el-table-column prop="icon" label="图标" width="80" align="center">
            <template slot-scope="scope">
              <i v-if="scope.row.icon" :class="'el-icon-' + scope.row.icon"></i>
            </template>
          </el-table-column>
          <el-table-column prop="sort" label="排序" width="80" align="center"></el-table-column>
          <el-table-column prop="permission" label="权限标识" align="center"></el-table-column>
          <el-table-column prop="componentPath" label="组件路径" align="center"></el-table-column>
          <el-table-column prop="is_show" label="状态" width="" align="center">
            <template slot-scope="scope">
              <el-tag :type="scope.row.is_show == 1 ? 'success' : 'danger'">
                {{ scope.row.is_show == 1 ? '显示' : '隐藏' }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="createTime" label="创建时间" width="" align="center"></el-table-column>
          <el-table-column label="操作" width="" align="center">
            <template slot-scope="scope">
              <a href="javascript:void(0)" class="action-link" @click="handleEdit('isEdit', scope.row)">修改</a>
              <span class="action-separator">|</span>
              <a href="javascript:void(0)" class="action-link" @click="handleAddSub('isAddSub', scope.row)">新增子菜单</a>
              <span class="action-separator">|</span>
              <a href="javascript:void(0)" class="action-link" @click="handleDelete(scope.row)">删除</a>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>

    <!-- 新增/编辑对话框 -->
    <el-dialog :visible.sync="dialogVisible" :title="dialogTitle" width="1000px">
      <el-form :model="formData" :rules="rules" ref="formRef" label-width="120px" class="two-column-form">
        <!-- 上级菜单 -->
        <el-form-item label="上级菜单" prop="parentId" class="flex">
          <el-select v-model="formData.parentId" placeholder="请选择上级菜单">
            <el-option label="主类目" :value="0"></el-option>
            <el-option v-for="menu in menuOptions" :key="menu.id" :label="menu.menuName" :value="menu.id">
              <span :style="{ paddingLeft: (menu.level * 20) + 'px' }">{{ menu.menuName }}</span>
            </el-option>
          </el-select>
        </el-form-item>

        <!-- 菜单类型 -->
        <el-form-item label="菜单类型" prop="menuType" class="flex">
          <el-radio-group v-model="formData.menuType" @change="handleMenuTypeChange">
            <el-radio label="0">目录</el-radio>
            <el-radio label="1">菜单</el-radio>
            <el-radio label="2">按钮</el-radio>
          </el-radio-group>
        </el-form-item>

        <!-- 菜单图标 (目录和菜单显示) -->
        <el-form-item v-if="['0', '1'].includes(formData.menuType)" label="菜单图标" prop="icon" class="flex">
          <el-popover placement="bottom" width="800" trigger="click" v-model="iconPopoverVisible">
            <div class="icon-selector">
              <div class="icon-search">
                <el-input v-model="iconSearchText" placeholder="搜索图标" size="small"></el-input>
              </div>
              <div class="icon-list">
                <div v-for="icon in filteredIcons" :key="icon" class="icon-item"
                  :class="{ active: icon === formData.icon }" @click="selectIcon(icon)">
                  <i :class="'el-icon-' + icon"></i>
                  <span>{{ icon }}</span>
                </div>
              </div>
            </div>
            <template #reference>
              <el-input v-model="formData.icon" placeholder="点击选择图标" readonly>
                <template #append>
                  <i v-if="formData.icon" :class="`el-icon-${formData.icon.replace(/^el-icon-/, '')}`"></i>
                </template>
              </el-input>
            </template>
          </el-popover>
        </el-form-item>

        <!-- 显示排序 -->
        <el-form-item label="显示排序" prop="sort" class="flex">
          <el-input-number v-model="formData.sort" :min="0" :step="1" style="width: 100%"></el-input-number>
        </el-form-item>

        <!-- 菜单名称 -->
        <el-form-item label="菜单名称" prop="menuName" class="flex">
          <el-input v-model="formData.menuName" placeholder="请输入菜单名称"></el-input>
        </el-form-item>

        <!-- 路由名称 (仅菜单显示) -->
        <el-form-item v-if="formData.menuType === '1'" label="路由名称" prop="routeName" class="flex">
          <el-input v-model="formData.routeName" placeholder="请输入路由名称"></el-input>
        </el-form-item>

        <!-- 是否外链 (目录和菜单显示) -->
        <el-form-item v-if="['0', '1'].includes(formData.menuType)" label="是否外链" prop="isExternal" class="flex">
          <el-radio-group v-model="formData.isExternal">
            <el-radio label="1">是</el-radio>
            <el-radio label="0">否</el-radio>
          </el-radio-group>
        </el-form-item>

        <!-- 路由地址 (目录和菜单显示) -->
        <el-form-item v-if="['0', '1'].includes(formData.menuType)" label="路由地址" prop="routePath" class="flex">
          <el-input v-model="formData.routePath" placeholder="请输入路由地址"></el-input>
        </el-form-item>

        <!-- 组件路径 -->
        <el-form-item label="组件路径" prop="componentPath" class="flex">
          <el-input v-model="formData.componentPath" placeholder="请输入组件路径"></el-input>
        </el-form-item>

        <!-- 权限标识 (菜单和按钮显示) -->
        <el-form-item v-if="['1', '2'].includes(formData.menuType)" label="权限标识" prop="permission" class="flex">
          <el-input v-model="formData.permission" placeholder="请输入权限标识"></el-input>
        </el-form-item>

        <!-- 路由参数 (仅菜单显示) -->
        <el-form-item v-if="formData.menuType === '1'" label="路由参数" prop="routeParams" class="flex">
          <el-input v-model="formData.routeParams" placeholder="请输入路由参数"></el-input>
        </el-form-item>

        <!-- 是否缓存 (仅菜单显示) -->
        <el-form-item v-if="formData.menuType === '1'" label="是否缓存" prop="isCache" class="flex">
          <el-radio-group v-model="formData.isCache">
            <el-radio label="1">缓存</el-radio>
            <el-radio label="0">不缓存</el-radio>
          </el-radio-group>
        </el-form-item>

        <!-- 显示状态 (目录和菜单显示) -->
        <el-form-item v-if="['0', '1'].includes(formData.menuType)" label="显示状态" prop="displayStatus" class="flex">
          <el-radio-group v-model="formData.displayStatus">
            <el-radio label="1">显示</el-radio>
            <el-radio label="0">隐藏</el-radio>
          </el-radio-group>
        </el-form-item>

        <!-- 菜单状态 -->
        <!-- <el-form-item label="菜单状态" prop="status" class="flex">
          <el-radio-group v-model="formData.status">
            <el-radio label="1">启用</el-radio>
            <el-radio label="0">禁用</el-radio>
          </el-radio-group>
        </el-form-item> -->
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="handleSubmit">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { menuList, menuAdd, menuUpdate, menuDelete } from '@/api/api'

export default {
  name: 'MenuManage',
  data() {
    return {
      // 搜索表单
      searchForm: {
        menuName: '',
        is_show: ''
      },
      // 菜单列表数据
      menuList: [],
      // 加载状态
      loading: false,
      // 对话框状态
      dialogVisible: false,
      dialogTitle: '',
      // 操作类型标志
      operationType: '', // 'add', 'edit', 'addSub'
      // 表单数据
      formData: {
        id: '',
        parentId: 0,
        menuType: '0',
        icon: '',
        sort: 0,
        menuName: '',
        routeName: '',
        isExternal: '0',
        routePath: '',
        componentPath: '',
        permission: '',
        routeParams: '',
        isCache: '1',
        displayStatus: '1',
        status: '1'
      },
      // 表单验证规则
      rules: {
        menuName: [
          { required: true, message: '请输入菜单名称', trigger: 'blur' }
        ],
        sort: [
          { required: true, message: '请输入显示排序', trigger: 'blur' }
        ],
        routePath: [
          { required: true, message: '请输入路由地址', trigger: 'blur' }
        ],
        permission: [
          { required: true, message: '请输入权限标识', trigger: 'blur' }
        ]
      },
      // 菜单选项，用于上级菜单选择
      menuOptions: [],
      // 展开状态
      expandedMenus: {},
      // 图标选择器相关
      iconPopoverVisible: false,
      iconSearchText: '',
      // Element UI 2.15.14 版本内置有效图标列表（已移除不兼容的 circle-* 系列）
      icons: [
        // 基础/导航图标
        's-home', 'menu', 'setting', 'user', 'document', 'folder', 'picture',
        'office-building', 'grid', 'paperclip', 'camera', 'music',
        // 操作图标
        'plus', 'minus', 'close', 'check', 'delete', 'edit', 'share', 'refresh',
        'upload', 'download', 'search', 'view', 'print',
        // 状态图标（仅保留2.15.14支持的）
        'info', 'success', 'warning', 'error', 'question', 'loading', 'finished',
        // 方向性图标
        'arrow-up', 'arrow-down', 'arrow-left', 'arrow-right',
        'caret-top', 'caret-bottom', 'caret-left', 'caret-right',
        's-unfold', 's-fold',
        // 系统图标
        'bell', 'time', 'calendar', 'location', 'phone', 'mail', 'key', 'link',
        // 购物/其他
        'shopping-cart', 'star',
        // s-系列业务图标
        's-grid', 's-operation', 's-finance', 's-platform', 's-release',
        's-marketing', 's-shop', 's-custom', 's-help', 's-ticket', 's-tools',
        's-management', 's-protect', 's-refresh', 's-upload', 's-download',
        's-delete', 's-check', 's-question', 's-warning', 's-error', 's-success'
      ]
    }
  },
  computed: {
    // 过滤后的图标列表
    filteredIcons() {
      if (!this.iconSearchText) {
        return this.icons
      }
      return this.icons.filter(icon => icon.includes(this.iconSearchText.toLowerCase()))
    },
    // 扁平化菜单列表，用于表格显示
    flattenedMenuList() {
      const result = []

      const flatten = (menus, parentExpanded = true) => {
        // 添加类型检查，确保menus是数组
        if (!Array.isArray(menus)) {
          return
        }
        menus.forEach(menu => {
          // 添加hasChildren属性
          menu.hasChildren = menu.children && Array.isArray(menu.children) && menu.children.length > 0

          // 只有当父菜单展开时才显示子菜单
          if (parentExpanded) {
            result.push(menu)
          }

          // 递归处理子菜单
          if (menu.children && Array.isArray(menu.children) && menu.children.length > 0) {
            flatten(menu.children, parentExpanded && menu.expanded)
          }
        })
      }

      flatten(this.menuList)
      return result
    },
    // 检查是否所有菜单都已展开
    allExpanded() {
      const checkAllExpanded = (menus) => {
        // 添加类型检查，确保menus是数组
        if (!Array.isArray(menus)) {
          return true
        }
        for (const menu of menus) {
          // 确保expanded属性存在
          if (!Object.prototype.hasOwnProperty.call(menu, 'expanded') || !menu.expanded) {
            return false
          }
          if (menu.children && Array.isArray(menu.children) && menu.children.length > 0) {
            if (!checkAllExpanded(menu.children)) {
              return false
            }
          }
        }
        return true
      }
      return checkAllExpanded(this.menuList)
    }
  },
  mounted() {
    // 获取菜单列表
    this.fetchMenuList()
  },
  methods: {
    // 获取菜单列表
    fetchMenuList(searchParams = {}) {
      this.loading = true

      // 映射搜索参数到API参数
      const apiParams = {
        menu_name: searchParams.menuName || '',
        is_show: searchParams.is_show || ''
      }

      console.log('调用menuList接口，参数:', apiParams);
      menuList(apiParams)
        .then(response => {
          console.log('menuList接口响应:', response);
          if (response && response.code === 200 && response.data && response.data.list) {
            // 处理菜单数据，添加必要的属性
            this.menuList = this.processMenuData(response.data.list)
            // 初始化菜单选项
            this.initMenuOptions()
          } else {
            this.$message.error('获取菜单列表失败')
            this.menuList = []
          }
        })
        .catch(error => {
          console.error('获取菜单列表失败:', error)
          this.$message.error('获取菜单列表异常，请重试')
          this.menuList = []
        })
        .finally(() => {
          this.loading = false
        })
    },
    // 处理菜单数据，添加必要的属性
    processMenuData(menus, level = 0) {
      // 添加类型检查，确保menus是数组
      if (!Array.isArray(menus)) {
        return []
      }
      return menus.map(menu => {
        const processedMenu = {
          id: menu.id,
          menuName: menu.menu_name || '',
          icon: menu.icon || '',
          sort: menu.sort || 0,
          permission: menu.perms || '',
          componentPath: menu.component_path || '',
          routePath: menu.route_url || '',
          is_show: menu.is_show !== null && menu.is_show !== undefined ? menu.is_show : 1,
          status: menu.status !== null && menu.status !== undefined ? menu.status : 1,
          createTime: menu.created_at || '',
          level: level,
          expanded: true,
          parentId: menu.parent_id || 0,
          menuType: menu.type || 0
        }
        // 处理子菜单
        if (menu.children && Array.isArray(menu.children) && menu.children.length > 0) {
          processedMenu.children = this.processMenuData(menu.children, level + 1)
        }
        return processedMenu
      })
    },
    // 初始化菜单选项
    initMenuOptions() {
      const options = []

      const flattenMenu = (menus, level = 0) => {
        if (!Array.isArray(menus)) {
          return
        }
        menus.forEach(menu => {
          // 过滤掉id为0的菜单，因为主类目已经通过硬编码的方式添加到了选择器中
          if (menu.id !== 0) {
            options.push({
              id: menu.id,
              menuName: menu.menuName,
              level: level
            })
          }
          if (menu.children && Array.isArray(menu.children) && menu.children.length > 0) {
            flattenMenu(menu.children, level + 1)
          }
        })
      }

      flattenMenu(this.menuList)
      this.menuOptions = options
    },
    // 处理菜单类型变化
    handleMenuTypeChange() {
      console.log('菜单类型变化', this.formData.menuType)
      if (this.formData.menuType === '2') {
        // 如果是按钮类型，重置一些不需要的字段
        this.formData.icon = ''
        this.formData.isExternal = '0'
        this.formData.routePath = ''
        this.formData.routeName = ''
        this.formData.routeParams = ''
        this.formData.isCache = '1'
        this.formData.displayStatus = '1'
      }
    },
    // 搜索
    handleSearch() {
      console.log('搜索', this.searchForm)
      // 调用fetchMenuList方法，传递搜索参数
      this.fetchMenuList(this.searchForm)
    },
    // 重置
    handleReset() {
      this.searchForm = {
        menuName: '',
        is_show: ''
      }
      // 重置后重新获取菜单列表
      this.fetchMenuList()
    },
    // 新增
    handleAdd() {
      this.operationType = 'add'
      this.dialogTitle = '添加菜单'
      this.formData = {
        id: '',
        parentId: 0,
        menuType: '0',
        icon: '',
        sort: 0,
        menuName: '',
        routeName: '',
        isExternal: '0',
        routePath: '',
        componentPath: '',
        permission: '',
        routeParams: '',
        isCache: '1',
        displayStatus: '1',
        status: '1'
      }
      this.dialogVisible = true
    },
    // 新增子菜单
    handleAddSub(isAddSub, row) {
      this.operationType = 'addSub'
      this.dialogTitle = '添加菜单'
      this.formData = {
        // id: row.id, // 新增子菜单时不设置id
        parentId: row.id, // 父菜单ID设置为当前行的id
        menuType: '0',
        icon: '',
        sort: 0,
        menuName: '',
        routeName: '',
        isExternal: '0',
        routePath: '',
        componentPath: '',
        permission: '',
        routeParams: '',
        isCache: '1',
        displayStatus: '1',
        status: '1'
      }
      this.dialogVisible = true
    },
    // 修改
    handleEdit(isEdit, row) {
      this.operationType = 'edit'
      this.dialogTitle = '编辑菜单'
      this.formData = {
        id: row.id,
        parentId: row.parentId || 0,
        menuType: row.menuType ? row.menuType.toString() : '0',
        icon: row.icon || '',
        sort: row.sort || 0,
        menuName: row.menuName || '',
        routeName: row.routeName || '',
        isExternal: row.isExternal ? row.isExternal.toString() : '0',
        routePath: row.routePath || '',
        componentPath: row.componentPath || '',
        permission: row.permission || '',
        routeParams: row.routeParams || '',
        isCache: row.isCache ? row.isCache.toString() : '1',
        displayStatus: row.is_show ? row.is_show.toString() : '1',
        status: row.status ? row.status.toString() : '1'
      }
      this.dialogVisible = true
      console.log('编辑菜单', row, this.formData)
    },
    // 删除
    handleDelete(row) {
      this.$confirm(`确定要删除菜单「${row.menuName}」吗？`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        // 准备API参数
        const params = {
          id: row.id
        }

        console.log('调用menuDelete接口，参数:', params)

        // 调用API
        menuDelete(params)
          .then(response => {
            console.log('menuDelete接口响应:', response)
            if (response && response.code === 200) {
              this.$message.success('删除成功')
              // 重新获取菜单列表
              this.fetchMenuList()
            } else {
              this.$message.error('删除失败: ' + (response.message || '未知错误'))
            }
          })
          .catch(error => {
            console.error('删除失败:', error)
            this.$message.error('删除异常，请重试')
          })
      }).catch(() => {
        // 取消删除
      })
    },
    // 提交表单
    handleSubmit() {
      this.$refs.formRef.validate((valid) => {
        if (valid) {
          // 准备API参数
          const params = {
            type: this.formData.menuType,
            menu_name: this.formData.menuName,
            sort: this.formData.sort,
            route_url: this.formData.routePath,
            component_path: this.formData.componentPath,
            route_param: this.formData.routeParams,
            is_show: this.formData.displayStatus,
            perms: this.formData.permission,
            icon: this.formData.icon,
            parent_id: this.formData.parentId,
            id: this.formData.id
          }

          // 判断是新增还是修改
          const isEdit = this.operationType === 'edit'
          const apiMethod = isEdit ? menuUpdate : menuAdd
          const apiName = isEdit ? 'menuUpdate' : 'menuAdd'
          if (this.operationType === 'addSub') {
            params.parent_id = this.formData.parentId
          }

          console.log(`调用${apiName}接口，参数:`, params)

          // 调用API
          apiMethod(params)
            .then(response => {
              console.log(`${apiName}接口响应:`, response)
              if (response && response.code === 200) {
                this.dialogVisible = false
                this.$message.success('操作成功')
                // 重新获取菜单列表
                this.fetchMenuList()
              } else {
                this.$message.error('操作失败: ' + (response.message || '未知错误'))
              }
            })
            .catch(error => {
              console.error('操作失败:', error)
              this.$message.error('操作异常，请重试')
            })
        } else {
          return false
        }
      })
    },
    // 展开折叠
    toggleExpand() {
      // 检查当前是否有菜单是折叠的
      let hasCollapsed = false

      const checkCollapsed = (menus) => {
        if (!Array.isArray(menus)) {
          return
        }
        for (const menu of menus) {
          if (!menu.expanded) {
            hasCollapsed = true
            return
          }
          if (menu.children && Array.isArray(menu.children) && menu.children.length > 0) {
            checkCollapsed(menu.children)
            if (hasCollapsed) {
              return
            }
          }
        }
      }

      checkCollapsed(this.menuList)

      // 目标状态：如果有折叠的菜单，就展开所有；否则，折叠所有
      const targetState = hasCollapsed

      // 递归设置所有菜单的展开状态
      const toggleAll = (menus) => {
        if (!Array.isArray(menus)) {
          return
        }
        menus.forEach(menu => {
          // 确保expanded属性存在
          menu.expanded = targetState
          if (menu.children && Array.isArray(menu.children) && menu.children.length > 0) {
            toggleAll(menu.children)
          }
        })
      }

      toggleAll(this.menuList)
      // 强制Vue更新组件，确保UI能够正确反映菜单的展开状态
      this.$forceUpdate()
    },
    // 切换菜单展开状态
    toggleMenu(row) {
      row.expanded = !row.expanded
    },
    // 选择图标
    selectIcon(icon) {
      // 移除前缀，统一存储纯图标名
      this.formData.icon = icon.replace(/^el-icon-/, '');
      this.iconPopoverVisible = false;
    }
  }
}
</script>

<style lang="scss" scoped>
.search-form {
  .el-form-item {
    margin: 0 10px 0 0 !important;
  }

  ::v-deep .el-form-item__label {
    width: 120px !important;
  }
}

::v-deep .el-dialog__wrapper {
  top: inherit;
  height: 100%;
  display: flex;
}

::v-deep .el-dialog {
  min-height: 50%;
  overflow: hidden;
  /* overflow-y: scroll; */
}

::v-deep .el-form-item__content {
  width: 80%;
  margin-left: 0 !important;
}

.flex {
  display: flex;
  align-items: center;
}

/* 搜索表单布局 */
.search-form {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  margin-bottom: 20px;
  box-sizing: border-box;
}

/* 搜索表单左侧内容 */
.search-left {
  display: flex;
  align-items: center;
  gap: 15px;
}

/* 确保表单项垂直居中 */
.search-left .el-form-item {
  margin-bottom: 0;
  display: flex;
  align-items: center;
}

/* 调整状态标签和选择器的布局 */
.search-left .el-form-item__label {
  margin-right: 8px;
  white-space: nowrap;
}

/* 操作按钮容器 */
.action-buttons {
  display: flex;
  align-items: center;
  gap: 10px;
}

.menu-manage-container {
  padding: 20px;
  background-color: #fff;
  min-height: calc(100vh - 64px);
  max-width: 100%;
  box-sizing: border-box;
}

/* 确保对话框不被开发者工具遮挡 */
.el-dialog {
  z-index: 2020 !important;
}

/* 两列表单布局 */
.two-column-form {
  display: flex;
  flex-wrap: wrap;
  margin: -10px;
}

.two-column-form .el-form-item {
  flex: 0 0 calc(50% - 20px);
  margin: 10px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
}

/* 确保标签宽度一致 */
.two-column-form .el-form-item__label {
  width: 100px !important;
  flex-shrink: 0;
  text-align: right;
  margin-right: 15px;
}

/* 确保内容区域占满剩余空间 */
.two-column-form .el-form-item__content {
  flex: 1;
  min-width: 0;
}

/* 确保单选按钮组在一行显示 */
.two-column-form .el-form-item.flex {
  display: flex;
  align-items: center;
}

/* 调整表单元素宽度 */
.two-column-form .el-form-item__content {
  flex: 1;
}

.two-column-form .el-select,
.two-column-form .el-input,
.two-column-form .el-input-number {
  width: 100%;
}

.search-form {
  padding: 20px;
}

.action-buttons .el-button {
  margin-right: 10px;
}

/* 表格容器样式 */
.table-container {
  overflow: hidden;
  max-height: calc(100vh - 260px);
}

/* 表格滚动样式 */
.table-scroll {
  max-height: calc(100vh - 260px);
  overflow-y: auto;
  overflow-x: auto;
}

/* 自定义滚动条 */
.table-scroll::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

.table-scroll::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 4px;
}

.table-scroll::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 4px;
}

.table-scroll::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}

.el-table {
  background-color: #fff;
  border-radius: 8px;
  margin-bottom: 0;
}

.el-table th {
  background-color: #f5f7fa;
  font-weight: 600;
  position: sticky;
  top: 0;
  z-index: 10;
}

/* 操作链接样式 */
.action-link {
  color: #ff4d4f;
  text-decoration: none;
  margin: 0 5px;
  cursor: pointer;
}

.action-link:hover {
  text-decoration: underline;
}

.action-separator {
  color: #d9d9d9;
  margin: 0 2px;
}

.el-dialog {
  border-radius: 8px;
}

.el-dialog__header {
  background-color: #f5f7fa;
  border-bottom: 1px solid #ebeef5;
}

.el-dialog__title {
  font-weight: 600;
}

/* 确保对话框内容有足够的内边距 */
.el-dialog__body {
  padding: 20px;
}

/* 调整单选按钮组的间距 */
.el-radio-group {
  display: flex;
  gap: 20px;
}

/* 确保图标选择器弹出层不会影响对话框布局 */
.el-popover {
  z-index: 2000;
}

/* 图标选择器样式 */
.icon-selector {
  padding: 10px;
}

.icon-search {
  margin-bottom: 15px;
}

.icon-list {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  height: 300px;
  overflow-y: auto;
}

.icon-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 80px;
  height: 80px;
  border: 1px solid #e4e7ed;
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.3s ease;
}

/* 图标选中高亮 */
.icon-item.active {
  border-color: #409EFF;
  background-color: #ecf5ff;
}

.icon-item.active i,
.icon-item.active span {
  color: #409EFF;
}

.icon-item:hover {
  border-color: #409EFF;
  background-color: #ecf5ff;
}

.icon-item i {
  font-size: 24px;
  margin-bottom: 5px;
  color: #606266;
}

.icon-item span {
  font-size: 12px;
  color: #909399;
  text-align: center;
}

/* 自定义滚动条 */
.icon-list::-webkit-scrollbar {
  width: 8px;
}

.icon-list::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 4px;
}

.icon-list::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 4px;
}

.icon-list::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}
</style>